import type { ContractOtherCostItemData } from 'gql/graphql';
import { ContractOtherStatusEnum, ContractOtherConstructionTypeRelationStatusEnum } from 'gql/graphql';
import { IconConnection } from 'uikit';
import { formatNumberToRu } from 'utils';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';
import { useMemo, type CSSProperties } from 'react';

const WrapperStyle: CSSProperties = { display: 'flex', alignItems: 'center', flexWrap: 'nowrap' };
const iconStyle = { marginRight: 8 };

interface ICostOtherCellRendererComponent extends ICellRendererParams<ContractOtherCostItemData & { type: string }> {
    constructionTypeId?: number;
}

export const CostOtherCellRendererComponent: React.FC<ICostOtherCellRendererComponent> = (props) => {
    const { data, constructionTypeId } = props;

    const totalCost = useMemo(
        () =>
            data?.seasonLimits
                ?.filter(
                    (item: { constructionTypeId: number | undefined }) =>
                        item.constructionTypeId === constructionTypeId,
                )
                ?.reduce((sum: any, item: { cost: number }) => sum + item.cost, 0),
        [constructionTypeId, data],
    );

    const isNewRelationStatus = useMemo(
        () =>
            data?.status === ContractOtherStatusEnum.ContractCondition &&
            data?.constructionTypeLimits?.find((c) => c.constructionType.id === constructionTypeId)?.relationStatus ===
                ContractOtherConstructionTypeRelationStatusEnum.NewRecord,
        [constructionTypeId, data],
    );

    if (!data || data.type) {
        return <div />;
    }

    return (
        <div style={WrapperStyle}>
            {isNewRelationStatus && (
                <IconConnection key={`${data?.id}${constructionTypeId}`} size="s" view="link" style={iconStyle} />
            )}
            {totalCost !== 0 && formatNumberToRu(totalCost, 2)}
        </div>
    );
};

CostOtherCellRendererComponent.displayName = 'CostOtherCellRendererComponent';
